import { clearSessionActiveOrgId } from '@/lib/utils/activeOrganisation';
import { signOut } from 'next-auth/react';

type HandleSignOutOptions = {
  callbackUrl?: string;
};

let signOutInFlight: Promise<void> | null = null;

const getCallbackUrl = (value: HandleSignOutOptions | unknown): string => {
  if (value != null && typeof value === 'object' && 'callbackUrl' in value) {
    const callbackUrl = value.callbackUrl;

    if (typeof callbackUrl === 'string' && callbackUrl.length > 0) {
      return callbackUrl;
    }
  }

  return '/';
};

export const handleSignOut = async (options?: HandleSignOutOptions) => {
  const callbackUrl = getCallbackUrl(options);

  if (signOutInFlight != null) {
    return signOutInFlight;
  }

  clearSessionActiveOrgId();

  signOutInFlight = (async () => {
    const fallbackCallbackUrl = callbackUrl;

    try {
      const result = await signOut({ callbackUrl, redirect: false });
      const redirectUrl = result?.url ?? fallbackCallbackUrl;

      if (typeof window !== 'undefined') {
        window.location.replace(redirectUrl);
      }
    } catch (error) {
      console.error('Sign out failed:', error);

      if (typeof window !== 'undefined') {
        window.location.replace(fallbackCallbackUrl);
      }
    } finally {
      signOutInFlight = null;
    }
  })();

  try {
    await signOutInFlight;
  } finally {
    signOutInFlight = null;
  }
};
